export default {
  init() {
    // JavaScript to be fired on the Report Card page
    var stickEl = $('.sticky-side'),
      stickyElTop = stickEl.offset().top;

    var sticky = function () {
      var scrollTop = $(window).scrollTop();

      if (stickyElTop < scrollTop + 20) {
        stickEl.addClass('is-fixed');
      } else {
        stickEl.removeClass('is-fixed');
      }
    };

    $(window).scroll(function () {
      sticky();
    });
  },
  finalize() {
    // JavaScript to be fired on the Report Card page, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/report_card.js